import rpc from 'typescript/services/base_rpc_client';
import { RewardsService } from 'rpc/model/squareup/rewards/service';

export default RewardsService.create(rpc());
